export const translations = {
    en: {
        // Common
        common: {
            required: '*',
            loading: 'Loading...',
        },
        // Navbar
        nav: {
            shop: 'Shop',
            benefits: 'Benefits',
            faq: 'FAQ',
        },
        // Hero
        hero: {
            title: {
                part1: 'Natural Supplements for',
                part2: 'Your Best Life',
            },
            subtitle: 'Science-backed, nature-inspired formulas to support your sleep, focus, energy, and overall wellness.',
            shopNow: 'Shop Now',
            learnMore: 'Learn More',
            freeShipping: 'Free shipping on orders over $2,000 MXN',
        },
        // Benefits
        benefits: {
            title: 'Why Choose Machete?',
            subtitle: 'We\'re committed to providing the highest quality supplements backed by science and nature.',
            natural: {
                title: 'Natural Ingredients',
                desc: 'Sourced from nature, our supplements contain only the purest, most effective ingredients without artificial additives.',
            },
            tested: {
                title: 'Lab Tested',
                desc: 'Every batch is rigorously tested by third-party labs to ensure purity, potency, and safety.',
            },
            science: {
                title: 'Science-Backed',
                desc: 'Our formulas are developed based on the latest research and clinical studies in nutritional science.',
            },
            sustainable: {
                title: 'Sustainable',
                desc: 'We prioritize environmentally responsible sourcing and eco-friendly packaging.',
            },
        },
        // Categories
        categories: {
            title: 'Shop by Category',
            subtitle: 'Find the perfect supplement for your wellness goals',
            all: 'All',
            supplements: 'Supplements',
            books: 'Books',
            minerals: 'Minerals',
            medical: 'Medical Products',
            others: 'Others',
        },
        // Products
        products: {
            title: 'All Products',
            subtitle: 'Premium natural supplements for your wellness journey',
            noProducts: 'No products found.',
            soldOut: 'Sold Out',
            addToCart: 'Add to Cart',
            quantity: 'Quantity',
            size: 'Size',
            category: 'Category',
            loading: 'Loading products...',
        },
        // Product Detail
        product: {
            backToProducts: '← Back to Products',
            aboutThisProduct: 'About This Product',
            about: 'About This Product',
            qualityGuarantee: 'Quality Guarantee',
            qualityTitle: 'Quality Guarantee',
            outOfStock: 'Out of Stock',
            addToCart: 'Add to Cart',
            quantity: 'Quantity',
            size: 'Size',
            category: 'Category',
            quality: {
                tested: 'Third-party lab tested for purity and potency',
                gmp: 'Manufactured in GMP-certified facilities',
                guarantee: '30-day money-back guarantee',
                shipping: 'Free shipping on orders over $50',
            },
            productNotFound: 'Product Not Found',
            returnToHome: 'Return to Home',
        },
        // Product Detail Messages
        productDetail: {
            addedToCart: 'Added to cart!',
            goToCart: 'Go to cart?',
        },
        // Packages
        packages: {
            title: 'Special Packages',
            subtitle: 'Save more with our curated supplement packages',
            save: 'Save',
            includes: 'Includes:',
            addToCart: 'Add Package to Cart',
            noPackages: 'No packages available at the moment.',
        },
        // FAQ
        faq: {
            title: 'Frequently Asked Questions',
            subtitle: 'Everything you need to know about our supplements',
            q1: 'Are your supplements safe?',
            a1: 'Yes, all our supplements are manufactured in GMP-certified facilities and undergo rigorous third-party lab testing to ensure purity, potency, and safety.',
            q2: 'How long does shipping take?',
            a2: 'Standard shipping typically takes 3-5 business days. We also offer expedited shipping options at checkout.',
            q3: 'Can I return products?',
            a3: 'We offer a 30-day money-back guarantee. If you\'re not satisfied with your purchase, contact our support team for a full refund.',
            q4: 'Are the ingredients natural?',
            a4: 'Yes, we source only the purest natural ingredients without artificial additives, fillers, or preservatives.',
            q5: 'Do you ship internationally?',
            a5: 'Currently, we ship within Mexico and the United States. International shipping to other countries will be available soon.',
        },
        // Footer
        footer: {
            description: 'Premium natural supplements for your health and wellness journey.',
            shop: 'Shop',
            allProducts: 'All Products',
            support: 'Support',
            admin: 'Admin Login',
            developedBy: 'Developed by',
            copyright: '© 2024 Machete Supplements. All rights reserved.',
        },
        // Cart
        cart: {
            title: 'Shopping Cart',
            empty: {
                title: 'Your cart is empty',
                subtitle: 'Add some products to get started!',
            },
            continueShopping: 'Continue Shopping',
            clear: 'Clear Cart',
            clearConfirm: 'Are you sure you want to clear your cart?',
            orderSummary: 'Order Summary',
            subtotal: 'Subtotal',
            shipping: 'Shipping',
            free: 'FREE',
            total: 'Total',
            items: 'items',
            checkout: 'Proceed to Checkout',
        },
        // Checkout
        checkout: {
            title: 'Checkout',
            shippingInfo: 'Shipping Information',
            shippingInformation: 'Shipping Information',
            orderSummary: 'Order Summary',
            fullName: 'Full Name',
            email: 'Email',
            phone: 'Phone',
            address: 'Address',
            city: 'City',
            state: 'State / Province',
            zipCode: 'Zip Code',
            placeOrder: 'Place Order',
            placing: 'Placing Order...',
            placingOrder: 'Placing Order...',
            note: 'This is a demo checkout. No payment will be processed. Your order will be recorded for the store admin to review.',
            success: 'Order placed successfully!',
            orderPlaced: 'Order placed successfully!',
            orderNumber: 'Order #',
            confirmationEmail: 'We\'ll send you a confirmation email at',
            returnHome: 'Return to Home',
            continueShopping: 'Continue Shopping',
        },
        // Admin
        admin: {
            dashboard: 'Admin Dashboard',
            logout: 'Logout',
            title: 'Admin Dashboard',
            products: 'Products',
            packages: 'Packages',
            orders: 'Orders',
            addProduct: 'Add Product',
            addPackage: 'Add Package',
            search: 'Search products...',
            searchProducts: 'Search products...',
            edit: 'Edit',
            delete: 'Delete',
            markAvailable: 'Mark Available',
            markSoldOut: 'Mark Sold Out',
            available: 'Available',
            soldOut: 'Sold Out',
            actions: 'Actions',
            price: 'Price',
            category: 'Category',
            product: 'Product',
            status: 'Status',
            savings: 'Savings',
            deleteConfirm: 'Are you sure you want to delete this item?',
            deleteSuccess: 'Item deleted successfully!',
            deleteFailed: 'Failed to delete item',
            clearCartConfirm: 'Are you sure you want to clear your cart?',
            packageDeleteConfirm: 'Are you sure you want to delete this package?',
            packageDeleteSuccess: 'Package deleted successfully!',
            // Product Form
            productForm: {
                createTitle: 'Create Product',
                editTitle: 'Edit Product',
                name: 'Product Name',
                description: 'Description',
                price: 'Price',
                category: 'Category',
                size: 'Size',
                image: 'Product Image',
                soldOut: 'Mark as Sold Out',
                uploading: 'Uploading...',
                cancel: 'Cancel',
                create: 'Create Product',
                update: 'Update Product',
                categories: {
                    supplements: 'Supplements',
                    books: 'Books',
                    minerals: 'Minerals',
                    medical: 'Medical Products',
                    others: 'Others',
                },
            },
            // Package Form
            packageForm: {
                createTitle: 'Create Package',
                editTitle: 'Edit Package',
                name: 'Package Name',
                description: 'Description',
                originalPrice: 'Original Price',
                discountedPrice: 'Discounted Price',
                image: 'Package Image',
                products: 'Products',
                addProduct: 'Add Product',
                selectProduct: 'Select a product',
                productQuantity: 'Quantity',
                remove: 'Remove',
                uploading: 'Uploading...',
                cancel: 'Cancel',
                create: 'Create Package',
                update: 'Update Package',
            },
        },
        // Login
        login: {
            title: 'Admin Login',
            subtitle: 'Sign in to manage your store',
            email: 'Email',
            password: 'Password',
            signIn: 'Sign In',
            signingIn: 'Signing in...',
            backToStore: '← Back to Store',
        },
        // Form (Product & Package Forms)
        form: {
            // Common
            cancel: 'Cancel',
            create: 'Create',
            update: 'Update',
            saving: 'Saving...',
            uploading: 'Uploading...',
            active: 'Active',
            generate: 'Generate',
            // Product Form
            editProduct: 'Edit Product',
            addProduct: 'Add Product',
            productName: 'Product Name',
            slug: 'Slug (URL)',
            shortDesc: 'Short Description (English)',
            longDesc: 'Long Description (English)',
            shortDescEs: 'Short Description (Spanish)',
            longDescEs: 'Long Description (Spanish)',
            priceCents: 'Price (cents)',
            currency: 'Currency',
            category: 'Category',
            sizeLabel: 'Size Label',
            tags: 'Tags (comma separated)',
            productImage: 'Product Image',
            uploadImage: 'Upload Image',
            imageUrl: 'Image URL',
            pasteUrl: 'Or paste image URL',
            soldOut: 'Sold Out',
            // Package Form
            editPackage: 'Edit Package',
            addPackage: 'Add Package',
            packageName: 'Package Name',
            description: 'Description (English)',
            descriptionEs: 'Description (Spanish)',
            packagePrice: 'Package Price (cents)',
            originalPrice: 'Original Price (cents)',
            savings: 'savings',
            itemsIncluded: 'Items Included',
            itemsPerLine: 'One item per line',
            packageImage: 'Package Image',
            createPackage: 'Create Package',
            updatePackage: 'Update Package',
        },
    },
    es: {
        // Common
        common: {
            required: '*',
            loading: 'Cargando...',
        },
        // Navbar
        nav: {
            shop: 'Tienda',
            benefits: 'Beneficios',
            faq: 'Preguntas',
        },
        // Hero
        hero: {
            title: {
                part1: 'Suplementos Naturales para',
                part2: 'Tu Mejor Vida',
            },
            subtitle: 'Fórmulas respaldadas por la ciencia e inspiradas en la naturaleza para apoyar tu sueño, concentración, energía y bienestar general.',
            shopNow: 'Comprar Ahora',
            learnMore: 'Más Información',
            freeShipping: 'Envio gratis en pedidos mayores a $2,000 MXN',
        },
        // Benefits
        benefits: {
            title: '¿Por Qué Elegir Machete?',
            subtitle: 'Estamos comprometidos a proporcionar suplementos de la más alta calidad respaldados por la ciencia y la naturaleza.',
            natural: {
                title: 'Ingredientes Naturales',
                desc: 'Procedentes de la naturaleza, nuestros suplementos contienen solo los ingredientes más puros y efectivos sin aditivos artificiales.',
            },
            tested: {
                title: 'Probado en Laboratorio',
                desc: 'Cada lote es rigurosamente probado por laboratorios externos para garantizar pureza, potencia y seguridad.',
            },
            science: {
                title: 'Respaldado por la Ciencia',
                desc: 'Nuestras fórmulas se desarrollan basándose en las últimas investigaciones y estudios clínicos en ciencia nutricional.',
            },
            sustainable: {
                title: 'Sostenible',
                desc: 'Priorizamos el abastecimiento ambientalmente responsable y el empaque ecológico.',
            },
        },
        // Categories
        categories: {
            title: 'Comprar por Categoría',
            subtitle: 'Encuentra el suplemento perfecto para tus objetivos de bienestar',
            all: 'Todos',
            supplements: 'Suplementos',
            books: 'Libros',
            minerals: 'Minerales',
            medical: 'Productos Médicos',
            others: 'Otros',
        },
        // Products
        products: {
            title: 'Todos los Productos',
            subtitle: 'Suplementos naturales premium para tu viaje de bienestar',
            noProducts: 'No se encontraron productos.',
            soldOut: 'Agotado',
            addToCart: 'Agregar al Carrito',
            quantity: 'Cantidad',
            size: 'Tamaño',
            category: 'Categoría',
            loading: 'Cargando productos...',
        },
        // Product Detail
        product: {
            backToProducts: '← Volver a Productos',
            aboutThisProduct: 'Sobre Este Producto',
            about: 'Sobre Este Producto',
            qualityGuarantee: 'Garantía de Calidad',
            qualityTitle: 'Garantía de Calidad',
            outOfStock: 'Agotado',
            addToCart: 'Agregar al Carrito',
            quantity: 'Cantidad',
            size: 'Tamaño',
            category: 'Categoría',
            quality: {
                tested: 'Probado por laboratorios externos para pureza y potencia',
                gmp: 'Fabricado en instalaciones certificadas GMP',
                guarantee: 'Garantía de devolución de dinero de 30 días',
                shipping: 'Envío gratis en pedidos superiores a $50',
            },
            productNotFound: 'Producto No Encontrado',
            returnToHome: 'Volver al Inicio',
        },
        // Product Detail Messages
        productDetail: {
            addedToCart: '¡Agregado al carrito!',
            goToCart: '¿Ir al carrito?',
        },
        // Packages
        packages: {
            title: 'Paquetes Especiales',
            subtitle: 'Ahorra más con nuestros paquetes de suplementos seleccionados',
            save: 'Ahorra',
            includes: 'Incluye:',
            addToCart: 'Agregar Paquete al Carrito',
            noPackages: 'No hay paquetes disponibles en este momento.',
        },
        // FAQ
        faq: {
            title: 'Preguntas Frecuentes',
            subtitle: 'Todo lo que necesitas saber sobre nuestros suplementos',
            q1: '¿Son seguros sus suplementos?',
            a1: 'Sí, todos nuestros suplementos se fabrican en instalaciones certificadas GMP y se someten a rigurosas pruebas de laboratorio de terceros para garantizar pureza, potencia y seguridad.',
            q2: '¿Cuánto tarda el envío?',
            a2: 'El envío estándar generalmente tarda de 3 a 5 días hábiles. También ofrecemos opciones de envío acelerado al finalizar la compra.',
            q3: '¿Puedo devolver productos?',
            a3: 'Ofrecemos una garantía de devolución de dinero de 30 días. Si no está satisfecho con su compra, comuníquese con nuestro equipo de soporte para obtener un reembolso completo.',
            q4: '¿Son naturales los ingredientes?',
            a4: 'Sí, obtenemos solo los ingredientes naturales más puros sin aditivos artificiales, rellenos o conservantes.',
            q5: '¿Envían internacionalmente?',
            a5: 'Actualmente, enviamos dentro de México y Estados Unidos. El envío internacional a otros países estará disponible pronto.',
        },
        // Footer
        footer: {
            description: 'Suplementos naturales premium para tu salud y bienestar.',
            shop: 'Tienda',
            allProducts: 'Todos los Productos',
            support: 'Soporte',
            admin: 'Acceso Admin',
            developedBy: 'Desarrollado por',
            copyright: '© 2024 Machete Supplements. Todos los derechos reservados.',
        },
        // Cart
        cart: {
            title: 'Carrito de Compras',
            empty: {
                title: 'Tu carrito está vacío',
                subtitle: '¡Agrega algunos productos para comenzar!',
            },
            continueShopping: 'Continuar Comprando',
            clear: 'Vaciar Carrito',
            clearConfirm: '¿Estás seguro de que quieres vaciar tu carrito?',
            orderSummary: 'Resumen del Pedido',
            subtotal: 'Subtotal',
            shipping: 'Envío',
            free: 'GRATIS',
            total: 'Total',
            items: 'artículos',
            checkout: 'Proceder al Pago',
        },
        // Checkout
        checkout: {
            title: 'Finalizar Compra',
            shippingInfo: 'Información de Envío',
            shippingInformation: 'Información de Envío',
            orderSummary: 'Resumen del Pedido',
            fullName: 'Nombre Completo',
            email: 'Correo Electrónico',
            phone: 'Teléfono',
            address: 'Dirección',
            city: 'Ciudad',
            state: 'Estado / Provincia',
            zipCode: 'Código Postal',
            placeOrder: 'Realizar Pedido',
            placing: 'Procesando Pedido...',
            placingOrder: 'Procesando Pedido...',
            note: 'Esta es una demostración de pago. No se procesará ningún pago. Tu pedido será registrado para que el administrador de la tienda lo revise.',
            success: '¡Pedido realizado exitosamente!',
            orderPlaced: '¡Pedido realizado exitosamente!',
            orderNumber: 'Pedido #',
            confirmationEmail: 'Te enviaremos un correo de confirmación a',
            returnHome: 'Volver al Inicio',
            continueShopping: 'Continuar Comprando',
        },
        // Admin
        admin: {
            dashboard: 'Panel de Administración',
            logout: 'Cerrar Sesión',
            title: 'Panel de Administración',
            products: 'Productos',
            packages: 'Paquetes',
            orders: 'Pedidos',
            addProduct: 'Agregar Producto',
            addPackage: 'Agregar Paquete',
            search: 'Buscar productos...',
            searchProducts: 'Buscar productos...',
            edit: 'Editar',
            delete: 'Eliminar',
            markAvailable: 'Marcar Disponible',
            markSoldOut: 'Marcar Agotado',
            available: 'Disponible',
            soldOut: 'Agotado',
            actions: 'Acciones',
            price: 'Precio',
            category: 'Categoría',
            product: 'Producto',
            status: 'Estado',
            savings: 'Ahorros',
            deleteConfirm: '¿Estás seguro de que quieres eliminar este elemento?',
            deleteSuccess: '¡Elemento eliminado exitosamente!',
            deleteFailed: 'No se pudo eliminar el elemento',
            clearCartConfirm: '¿Estás seguro de que quieres vaciar tu carrito?',
            packageDeleteConfirm: '¿Estás seguro de que quieres eliminar este paquete?',
            packageDeleteSuccess: '¡Paquete eliminado exitosamente!',
            // Product Form
            productForm: {
                createTitle: 'Crear Producto',
                editTitle: 'Editar Producto',
                name: 'Nombre del Producto',
                description: 'Descripción',
                price: 'Precio',
                category: 'Categoría',
                size: 'Tamaño',
                image: 'Imagen del Producto',
                soldOut: 'Marcar como Agotado',
                uploading: 'Subiendo...',
                cancel: 'Cancelar',
                create: 'Crear Producto',
                update: 'Actualizar Producto',
                categories: {
                    supplements: 'Suplementos',
                    books: 'Libros',
                    minerals: 'Minerales',
                    medical: 'Productos Médicos',
                    others: 'Otros',
                },
            },
            // Package Form
            packageForm: {
                createTitle: 'Crear Paquete',
                editTitle: 'Editar Paquete',
                name: 'Nombre del Paquete',
                description: 'Descripción',
                originalPrice: 'Precio Original',
                discountedPrice: 'Precio con Descuento',
                image: 'Imagen del Paquete',
                products: 'Productos',
                addProduct: 'Agregar Producto',
                selectProduct: 'Seleccionar un producto',
                productQuantity: 'Cantidad',
                remove: 'Eliminar',
                uploading: 'Subiendo...',
                cancel: 'Cancelar',
                create: 'Crear Paquete',
                update: 'Actualizar Paquete',
            },
        },
        // Login
        login: {
            title: 'Acceso de Administrador',
            subtitle: 'Inicia sesión para administrar tu tienda',
            email: 'Correo Electrónico',
            password: 'Contraseña',
            signIn: 'Iniciar Sesión',
            signingIn: 'Iniciando sesión...',
            backToStore: '← Volver a la Tienda',
        },
        // Form (Product & Package Forms)
        form: {
            // Common
            cancel: 'Cancelar',
            create: 'Crear',
            update: 'Actualizar',
            saving: 'Guardando...',
            uploading: 'Subiendo...',
            active: 'Activo',
            generate: 'Generar',
            // Product Form
            editProduct: 'Editar Producto',
            addProduct: 'Agregar Producto',
            productName: 'Nombre del Producto',
            slug: 'Slug (URL)',
            shortDesc: 'Descripción Corta (Inglés)',
            longDesc: 'Descripción Larga (Inglés)',
            shortDescEs: 'Descripción Corta (Español)',
            longDescEs: 'Descripción Larga (Español)',
            priceCents: 'Precio (centavos)',
            currency: 'Moneda',
            category: 'Categoría',
            sizeLabel: 'Etiqueta de Tamaño',
            tags: 'Etiquetas (separadas por comas)',
            productImage: 'Imagen del Producto',
            uploadImage: 'Subir Imagen',
            imageUrl: 'URL de la Imagen',
            pasteUrl: 'O pega la URL de la imagen',
            soldOut: 'Agotado',
            // Package Form
            editPackage: 'Editar Paquete',
            addPackage: 'Agregar Paquete',
            packageName: 'Nombre del Paquete',
            description: 'Descripción (Inglés)',
            descriptionEs: 'Descripción (Español)',
            packagePrice: 'Precio del Paquete (centavos)',
            originalPrice: 'Precio Original (centavos)',
            savings: 'ahorros',
            itemsIncluded: 'Artículos Incluidos',
            itemsPerLine: 'Un artículo por línea',
            packageImage: 'Imagen del Paquete',
            createPackage: 'Crear Paquete',
            updatePackage: 'Actualizar Paquete',
        },
    },
};
